import React, {Component} from 'react';
import DocProperties from '../Properties/DocProperties'
import ElementProps from '../ElempentProps';
import objeler from '../objeler';
import ModalBase from './ModaBase';

class ModalDialogDoc extends Component<props> {
    static defaultProps = {
        objects: {}
    };
    customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: '800px',
            height: '550px',
            transform: 'translate(-50%, -50%)'
        }
    };

    constructor(props) {
        super(props);
        this.state = {modalDocIsOpen: false, setDocIsOpen: false, ElementProps};
        this.FilePropRef = React.createRef();
    }

    afterOpenModal = () => {
    }
    closeModal = (b) => {
        if (b !== "Cancel") {
            objeler.ModalDocParameters = {...objeler.ModalDocValues};
            objeler.ModalDocValues = {};
            this.props.closeModal("dosya ismi");
        } else {
            objeler.ModalDocValues = {};
            this.props.closeModal("Cancel");
        }
        return;
        objeler.closeModalFile(e);
        if (b === "OK")
            this.props.closeModalFile(objeler.tarik);
        else
            this.props.closeModalFile("Cancel");
    }

    render() {
        const {objects, DocProps} = this.props;
        const {classes} = this.props;
        return (
            <div>
                {objeler.ModalDocParameters !== null && <ModalBase
                    isOpen={this.props.isOpen}
                    closeModal={this.closeModal}
                    title={'Document Preferences'}
                >
                    <table className="ta ble" height="90%" style={{border: "2px"}}>
                        <tbody>
                        <tr>
                            <td scope="col" colSpan="3">
                                <DocProperties onDocChange={this.onDocChange}
                                               FileName={objeler.ModalDocParameters.FileName}
                                               DocProps={objeler.ModalDocParameters}></DocProperties>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </ModalBase>}
            </div>
        );
    }
}

export default ModalDialogDoc;